import React from 'react';

// Organization Schema
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Nimble Group",
  "url": "https://nimblegogreen.com",
  "logo": "https://nimblegogreen.com/nimble-logo.png",
  "description": "Leading provider of eco-friendly and sustainable chemical solutions with 25+ years of expertise",
  "foundingDate": "1996",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN",
    "addressRegion": "India"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "url": "https://nimblegogreen.com/contact"
  },
  "sameAs": [
    "https://nimblegogreen.com"
  ]
};

// Website Schema
export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Nimble Group",
  "url": "https://nimblegogreen.com",
  "description": "Eco-friendly and sustainable chemical solutions",
  "publisher": {
    "@type": "Organization",
    "name": "Nimble Group"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://nimblegogreen.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

// Service Schema for Business Pages
export const serviceSchema = (serviceName, description, serviceType) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "name": serviceName,
  "description": description,
  "provider": {
    "@type": "Organization",
    "name": "Nimble Group",
    "url": "https://nimblegogreen.com"
  },
  "serviceType": serviceType,
  "areaServed": {
    "@type": "Country",
    "name": "India"
  }
});

// Breadcrumb Schema
export const breadcrumbSchema = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": crumb.name,
    "item": crumb.url
  }))
});

// FAQ Schema
export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

// Offers Schema for Product Pricing
export const offersSchema = (price = null, availability = "InStock", priceCurrency = "INR") => {
  const offer = {
    "@type": "Offer",
    "availability": `https://schema.org/${availability}`,
    "priceCurrency": priceCurrency,
    "priceValidUntil": new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toISOString().split('T')[0], // 1 year from now
    "seller": {
      "@type": "Organization",
      "name": "Nimble Group",
      "url": "https://nimblegogreen.com"
    },
    "url": "https://nimblegogreen.com/contact"
  };
  
  // Only include price if it's a valid number
  if (price !== null && price !== undefined && !isNaN(parseFloat(price))) {
    offer.price = parseFloat(price).toString();
  }
  
  return offer;
};

// Product Schema for Chemical Solutions
export const productSchema = (productName, description, category, price = null, availability = "InStock", imageUrl = null) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  "name": productName,
  "description": description,
  "category": category,
  "image": imageUrl || "https://nimblegogreen.com/nimble-logo.png", // Default to logo if no image provided
  "brand": {
    "@type": "Brand",
    "name": "Nimble Group"
  },
  "manufacturer": {
    "@type": "Organization",
    "name": "Nimble Group"
  },
  "offers": offersSchema(price, availability)
});

// Local Business Schema
export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Nimble Group",
  "description": "Eco-friendly chemical solutions provider",
  "url": "https://nimblegogreen.com",
  "telephone": "+91-7249447788",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN",
    "addressRegion": "India"
  },
  "openingHours": "Mo-Fr 09:00-18:00",
  "priceRange": "$$"
};
